(function () {
  'use strict';

  function setPlusMinus(head, symbol) {
    var icon = head.querySelector('.plusminus');
    if (icon) icon.textContent = symbol;
  }

  function isBodyOpen(head, body) {
    if (head.classList.contains('active')) return true;
    if (body.hasAttribute('hidden')) return false;
    return body.offsetHeight > 0 && window.getComputedStyle(body).display !== 'none';
  }

  function hideBody(body) {
    body.removeAttribute('hidden');
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slideUp) {
      window.jQuery(body).stop(true, true).slideUp(300);
      return;
    }
    body.style.display = 'none';
  }

  function showBody(body) {
    body.removeAttribute('hidden');
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slideDown) {
      window.jQuery(body).stop(true, true).slideDown(300);
      return;
    }
    body.style.display = 'block';
  }

  function closeAllInContainer(container) {
    container.querySelectorAll('.accordion_head').forEach(function (head) {
      head.classList.remove('active');
      head.setAttribute('aria-expanded', 'false');
      setPlusMinus(head, '+');
    });

    container.querySelectorAll('.accordion_body').forEach(function (body) {
      hideBody(body);
    });
  }

  function openItem(head, body) {
    head.classList.add('active');
    head.setAttribute('aria-expanded', 'true');
    setPlusMinus(head, '-');
    showBody(body);
  }

  function handleAccordionClick(event) {
    var head = event.target.closest('.accordion_head');
    if (!head) return;

    var body = head.nextElementSibling;
    if (!body || !body.classList.contains('accordion_body')) return;

    event.preventDefault();
    event.stopPropagation();

    var container = head.closest('.accordion_container') || head.parentElement;
    if (!container) return;

    var wasOpen = isBodyOpen(head, body);
    closeAllInContainer(container);

    if (!wasOpen) {
      openItem(head, body);
    }
  }

  function handleFaqDetailsToggle(event) {
    var item = event.target;
    if (!item || !item.classList || !item.classList.contains('rb-faqs__item')) return;
    if (!item.open) return;

    var accordion = item.closest('.rb-faqs__accordion');
    if (!accordion) return;

    accordion.querySelectorAll('.rb-faqs__item').forEach(function (other) {
      if (other !== item) other.removeAttribute('open');
    });
  }

  function enhanceAccordionHeads() {
    document.querySelectorAll('.accordion_head').forEach(function (head) {
      if (head.dataset.rbAccordionEnhanced === '1') return;
      head.dataset.rbAccordionEnhanced = '1';
      if (!head.hasAttribute('role')) head.setAttribute('role', 'button');
      if (!head.hasAttribute('tabindex')) head.setAttribute('tabindex', '0');
      if (!head.hasAttribute('aria-expanded')) head.setAttribute('aria-expanded', 'false');
    });
  }

  function handleAccordionKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var head = event.target.closest('.accordion_head');
    if (!head) return;
    event.preventDefault();
    head.click();
  }

  function bind() {
    enhanceAccordionHeads();
  }

  document.addEventListener('click', handleAccordionClick);
  document.addEventListener('keydown', handleAccordionKeydown);
  document.addEventListener('toggle', handleFaqDetailsToggle, true);
  document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
  bind();
})();
